import {Injectable} from "@angular/core";
import {Observable} from "rxjs";

import {
  ContractType,
  InsuranceDocumentDto,
  Partner,
  UserAddedInsuranceDocumentDto,
  UserAddedInsuranceDto
} from "../types/ds-user-added-insurance.types";
import {CoreApiService} from "../../../core/service/core-api.service";
import {FormDto} from "../../../core/interfaces/core.types";
import {HttpEvent} from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export abstract class InsurableObjectService {

  endPoint: string = "mvseu/eu/euUserInsurances"

  constructor(protected coreApiService: CoreApiService) {
  }

  public list() : Observable<UserAddedInsuranceDto[]> {
    return this.coreApiService.getList(this.endPoint);
  }

  public get(id: number) : Observable<UserAddedInsuranceDto> {
    return this.coreApiService.get(`${this.endPoint}/${id}`);
  }

  public template() : Observable<FormDto> {
    return this.coreApiService.get(`${this.endPoint}/template`);
  }

  public partners(searchString: string) : Observable<Partner[]> {
    return this.coreApiService.getList(`${this.endPoint}/partners?searchString=${searchString}`);
  }

  public contractTypes(searchString: string) : Observable<ContractType[]> {
    return this.coreApiService.getList(`${this.endPoint}/contractTypes?searchString=${searchString}`);
  }

  public create(dto: UserAddedInsuranceDto) : Observable<UserAddedInsuranceDto> {
    return this.coreApiService.create(dto, this.endPoint);
  }

  public update(dto: UserAddedInsuranceDto) : Observable<UserAddedInsuranceDto> {
    return this.coreApiService.update(dto, `${this.endPoint}/${dto.id}`);
  }

  public createDocument(addedInsuranceId: number, file: File) : Observable<HttpEvent<any>> {
    //return this.coreApiService.create(`${this.endPoint}/${addedInsuranceId}/document`);
    return this.coreApiService.upload(file, `${this.endPoint}/${addedInsuranceId}/document`);
  }

  public createDocumentBase64(addedInsuranceId: number, dto: UserAddedInsuranceDocumentDto) : Observable<any> {
    return this.coreApiService.create(dto,`${this.endPoint}/${addedInsuranceId}/documentBase64`);
  }

  public deleteDocument(addedInsuranceId: number, documentId: number) : Observable<any> {
    return this.coreApiService.delete(`${this.endPoint}/${addedInsuranceId}/document/${documentId}`);
  }

  public getDocumentBinary(addedInsuranceId: number, documentId: number) : Observable<any> {
    return this.coreApiService.getDocumentBinary(`${this.endPoint}/${addedInsuranceId}/document/${documentId}/$`);
  }

  public getDocumentBase64(addedInsuranceId: number, documentId: number) : Observable<InsuranceDocumentDto> {
    return this.coreApiService.get(`${this.endPoint}/${addedInsuranceId}/document/${documentId}/base64`);
  }

  public delete(id: number) : Observable<UserAddedInsuranceDto> {
    return this.coreApiService.delete(`${this.endPoint}/${id}`);
  }


}
